import React from 'react'
import ShippingPaneForm from './ShippingPaneForm'

import './shipping_pane.scss'

export const ShippingPane = ({ cart, user }) => {
  return (
    <div className="shipping-pane-container">
      <ShippingPaneForm cart={cart} user={user} />
    </div>
  )
}

export default ShippingPane
